<div class="row mt-1 regulatory_row">
    <app-progress-bar [isLoading]="isLoadingFilters"></app-progress-bar>
    <div class="col-md-3 col-lg-3">
      <div class="form-group">
        <div class="left inline control-label mb-1">Date From</div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="picker" (click)="picker.open()" placeholder="Choose a date"
            class="form-control form-control-sm border-bottom" id="fromDate" placeholder="From"
            [(ngModel)]="impactAssessmentFilter.fromDate" readonly>
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
          </div>
        </div>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>
    <div class="col-md-3 col-lg-3">
      <div class="form-group">
        <div class="left inline control-label d-none d-sm-block mb-1">Date Until</div>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" placeholder="Choose a date"
            class="form-control form-control-sm border-bottom" id="toDate" placeholder="To"
            [(ngModel)]="impactAssessmentFilter.toDate" readonly>
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
          </div>
        </div>
        <mat-datepicker #toPicker></mat-datepicker>
      </div>
    </div>
    <div class="col-md-3 col-lg-3">
      <div class="form-group">
        <div class="left inline control-label mb-1">Assessment Team</div>
        <mat-chip-grid #aTList>
          <ng-container *ngFor="let assessmentTeam of impactAssessmentFilter.assessmentTeam">
            <mat-chip-row
              [selectable]="selectable"
              [removable]="removable"
              (removed)="removeAT(assessmentTeam)"
              class="mat-chip-category {{assessmentTeam }}"
            >
              {{ assessmentTeam }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
          </ng-container>
         
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #aTInput
            [formControl]="searchATCntrl" [matAutocomplete]="aTAutocomplete" [matChipInputFor]="aTList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
            (matChipInputTokenEnd)="addAT($event)">
        </mat-chip-grid>
        <mat-autocomplete #aTAutocomplete="matAutocomplete" (optionSelected)="selectedATEvent($event)">
          <mat-option *ngFor="let obj of searchedAT" [value]="obj.value">
            {{obj.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="col-md-3 col-lg-3">
      <div class="form-group">
        <div class="left inline control-label mb-1">Assessment Status</div>
        <mat-chip-grid #aSList>
          <ng-container *ngFor="let assessmentStatus of impactAssessmentFilter.assessmentStatus">
            <mat-chip-row
              [selectable]="selectable"
              [removable]="removable"
              (removed)="removeAS(assessmentStatus)"
              class="mat-chip-category {{assessmentStatus }}"
            >
              {{ assessmentStatus }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
          </ng-container>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #aSInput
            [formControl]="searchASCntrl" [matAutocomplete]="aSAutocomplete" [matChipInputFor]="aSList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
            (matChipInputTokenEnd)="addAS($event)">
        </mat-chip-grid>
        <mat-autocomplete #aSAutocomplete="matAutocomplete" (optionSelected)="selectedASEvent($event)">
          <mat-option *ngFor="let obj of searchedAS" [value]="obj.value">
            {{obj.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="col-md-3 col-lg-3">
      <div class="form-group">
        <div class="left inline control-label mb-1">Assessor</div>
        <mat-chip-grid #assList>
          <ng-container *ngFor="let assessor of impactAssessmentFilter.assessor">
            <mat-chip-row
              [selectable]="selectable"
              [removable]="removable"
              (removed)="removeAssessor(assessor)"
              class="mat-chip-category {{assessor }}"
            >
              {{ assessor }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
          </ng-container>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #assInput
            [formControl]="searchAssCntrl" [matAutocomplete]="assAutocomplete" [matChipInputFor]="assList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
            (matChipInputTokenEnd)="addAssessor($event)">
        </mat-chip-grid>
        <mat-autocomplete #assAutocomplete="matAutocomplete" (optionSelected)="selectedAssessorEvent($event)">
          <mat-option *ngFor="let obj of searchedAss" [value]="obj.value">
            {{obj.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <!-- <div class="col-md-3 col-lg-3">
      <div class="form-group">
        <div class="left inline control-label mb-1">Implementation Team</div>
        <mat-chip-grid #iTList>
          <mat-chip-row *ngFor="let objItem of impactAssessmentFilter.implementationTeam" [selectable]="selectable"
            [removable]="removable" (removed)="removeIT(objItem)">
            {{objItem}}
            <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #actTInput
            [formControl]="searchITCntrl" [matAutocomplete]="iTAutocomplete" [matChipInputFor]="iTList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
            (matChipInputTokenEnd)="addIT($event)">
        </mat-chip-grid>
        <mat-autocomplete #iTAutocomplete="matAutocomplete" (optionSelected)="selectedITEvent($event)">
          <mat-option *ngFor="let obj of searchedIT" [value]="obj.value">
            {{obj.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div> -->
    <div class="col-md-2 col-lg-2">
      <div class="form-group">
        <div class="left inline control-label mb-1">Division</div>
        <mat-chip-grid #jurisList>
          <ng-container *ngFor="let jurisdiction of impactAssessmentFilter.jurisdiction">
            <mat-chip-row
              [selectable]="selectable"
              [removable]="removable"
              (removed)="removeJurisdiction(jurisdiction)"
              class="mat-chip-category {{jurisdiction }}"
            >
              {{ jurisdiction }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
          </ng-container>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #jurisInput
            [formControl]="searchJurisCntrl" [matAutocomplete]="jurisAutocomplete" [matChipInputFor]="jurisList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
            (matChipInputTokenEnd)="addJurisdiction($event)">
        </mat-chip-grid>
        <mat-autocomplete #jurisAutocomplete="matAutocomplete" (optionSelected)="selectedJurisdictionEvent($event)">
          <mat-option *ngFor="let obj of searchedJuris" [value]="obj.value">
            {{obj.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="col-md-2 col-lg-2">
      <div class="form-group">
        <div class="left inline control-label mb-1">Key Words</div>
        <mat-chip-grid #keywordsList>
          <ng-container *ngFor="let searchQuery of impactAssessmentFilter.searchQuery">
            <mat-chip-row
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(searchQuery)"
              class="mat-chip-category {{searchQuery }}"
            >
              {{ searchQuery }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip-row>
          </ng-container>
          <input class="form-control form-control-sm mat-autodd-input border-bottom" #keywordInput [formControl]="keyCtrl"
            [matAutocomplete]="autoKeyword" [matChipInputFor]="keywordsList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-grid>
        <mat-autocomplete #autoKeyword="matAutocomplete" (optionSelected)="selected($event)">
          <mat-option *ngFor="let fK of filteredKeywords" [value]="fK">
            {{fK}}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="form-group">
        <div class="left inline control-label mb-1">Id </div>
        <mat-chip-grid #idList>
          <mat-chip-row *ngFor="let type of impactAssessmentFilter.RegulationId" [selectable]="selectable" [removable]="removable"
            (removed)="removeRegulationId(type)">
            {{type}}
            <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm border-bottom" type="number" id="type" autocomplete="off"
            [matChipInputFor]="idList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRegulationId($event)">
        </mat-chip-grid>
      </div>
    </div>
  </div>
  <div class="row justify-content-end regulatory_row">
    <div class="col-md-3 col-lg-3 pt-1">
      <div class="form-group text-right">
        <span class="ml-2 btn btn-sm pl-1" (click)="initFilters()">Reset</span>
        <button type="button" class="btn btn-sm bg-purple text-white ml-2 btn-blue text-white" id="btn-search"
          (click)="TriggerAction()">Submit</button>
      </div>
    </div>
  </div>
  